'use strict';

var $ = require('jquery');
var deparam = require('jquery-deparam');

var myAnalytics = require('@plaudit/analytics').Analytics.getInstance();

function collapseState(state) {
	var collapsed = {};
	for (var key in state) {
		if (!state.hasOwnProperty(key))
			continue;

		var value = state[key];
		for (var valueKey in value) {
			if (!value.hasOwnProperty(valueKey))
				continue;

			collapsed[key + '.' + valueKey] = value[valueKey];
		}
	}
	return collapsed;
}
function expandState(collapsed) {
	// console.log(collapsed);
	var expanded = {};
	for (var key in collapsed) {
		if (!collapsed.hasOwnProperty(key))
			continue;

		var index = key.indexOf('.');
		if (index === -1) {
			expanded[key] = collapsed[key];
		} else {
			var base = key.substring(0, index);
			var prop = key.substring(index + 1);

			if (expanded[base] === undefined)
				expanded[base] = {};


			expanded[base][prop] = Array.isArray(collapsed[key]) ? collapsed[key] : [collapsed[key]];
		}


	}
	return expanded;
}

function StateHolder(name) {
	this.state = {};
	this.name = name;
}
StateHolder.prototype.getStateTitle = function() {
	return null;
}
StateHolder.prototype.save = function(state) {
	// Add state information
	state[this.name] = $.extend(true, {}, this.state);
}

StateHolder.prototype.load = function(state) {
	var prevState = this.state;

	var myState = state === null || !state.hasOwnProperty(this.name) ? undefined : state[this.name];

	if (myState === undefined) {
		myState = {};
	} else {
		// Clone it
		myState = $.extend(true, {}, myState);
	}

	this.state = myState;

	this.loaded(prevState);
}
StateHolder.prototype.loaded = function(prevState) {
	// Specific to each implementation
}


function StateManager() {
	this.stateHolders = [];
}
StateManager.prototype.add = function(stateHolder) {
	this.stateHolders.push(stateHolder);

	if (this.lastKnownState !== undefined && this.lastKnownState.hasOwnProperty(stateHolder.name)) {
		// Load into the stateHolder what it should have
		stateHolder.load(this.lastKnownState);
	}
}
StateManager.prototype.load = function(state) {
	this.lastKnownState = state;

	for (var i = 0; i < this.stateHolders.length; i++) {
		this.stateHolders[i].load(state);
	}
}
StateManager.prototype.getCurrentState = function() {
	// Gather new state data
	var state = {};
	for (var i = 0; i < this.stateHolders.length; i++) {
		this.stateHolders[i].save(state);
	}

	return state;
}

/**
 * Creates a title for the state.
 */
StateManager.prototype.getStateTitle = function() {
	var title = null;
	for (var i = 0; i < this.stateHolders.length; i++) {
		var myTitle = this.stateHolders[i].getStateTitle();
		if (myTitle !== null && myTitle !== '') {
			if (title === null) {
				title = myTitle;
			} else {
				title += ' | ' + myTitle;
			}
		}
	}

	if (title !== null) {
		title = document.title + ' | ' + title;
	}

	return title;
}
StateManager.prototype.save = function(refresh, rootUrl) {
	if (refresh === undefined)
		refresh = true;

	var state = this.getCurrentState();

	var stateForParams = collapseState(state);
	var params = $.param(stateForParams);
	// Kind of a hack, but '%5B%5D' look ugly and make the url long so we replace them with '[]'
	params = params.replace(/%5B%5D/g, '');

	if (rootUrl === undefined) {
		rootUrl = document.location.href;
	}
	var paramIndex = rootUrl.indexOf('?');
	if (paramIndex !== -1) {
		rootUrl = rootUrl.substring(0, paramIndex);
	}
	if (params.length > 0) {
		rootUrl += '?' + params;
	}

	this.lastKnownState = state;

	var title = instance.getStateTitle();
	if (refresh === true) {
		// Add to history, and cause stateholders to load state
		history.pushState(state, title, rootUrl);
	} else {
		//  Add to history without loading
		history._pushState(prepForSerializing(state), title, rootUrl);
	}
}

/**
 * Loads the state from the history or location query parameters.
 */
StateManager.prototype.init = function() {
	// Load current state from url query parameters
	var search = document.location.search;
	if (search != null && search.length > 1 && search[0] === '?') {
		// Load state from query parameters
		var stateFromParam = expandState(deparam(search.substring(1)));
		instance.load(stateFromParam);

		// Track in analytics
		var title = instance.getStateTitle();
		reportPageView(document.location.href, title);
	} else if (history.state !== null) {
		// Load state from history
		instance.load(history.state);

		// Track in analytics
		var title = instance.getStateTitle();
		reportPageView(document.location.href, title);
	}
}

/**
 * RichFaces modifies the Array.prototype which causes it to be on-serializable. By doing the following
 * we are able to serialize. (NOTE we use [] instead of 'new Array'. This is important)
 *
 * @param a
 * @returns
 */
function prepForSerializing(a) {
	if (Object(a) !== a) {
		// Primitive
		return a;
	}

	var r;
	if (Array.isArray(a)) {
		r = [];
		for (var i=0; i < a.length; i++) {
			r[i] = prepForSerializing(a[i]);
		}
	} else if (typeof(a) === 'object') {
		r = {};
		for(var key in a) {
	        if (a.hasOwnProperty(key)) {
	            r[key] = prepForSerializing(a[key]);
	        }
	    }
	} else {
		// console.log('Unsupported: ', a);
		throw new Error('Unsupported' + a);
	}

	return r;
}

/**
 * We ONLY report pageViews that have a title. We do this so if no StateHodler returns a title
 * we don't track pageView. (So a StateHolder providing a title is essentially saying "yes,
 * let's report a pageView to Google Analytics)
 *
 * @param url
 * @param title
 * @returns
 */
var prevPageView = makeRelativeToBaseHref(document.location.href);
var prevTitle = null;
function reportPageView(url, title, alwaysReport) {
	if (title === null || prevTitle === title)
		return;

	url = makeRelativeToBaseHref(url);

	if (prevPageView === url)
		return;

	myAnalytics.trackPageview(url, title);
	prevPageView = url;
	prevTitle = title;
}

function makeRelativeToBaseHref(url) {
	var baseHref = document.getElementsByTagName('base')[0].href;
	var index = url.indexOf(baseHref);
	if (index !== -1) {
		url = url.substring(index + baseHref.length);
	}
	return url;
}


// Singleton
var instance = new StateManager();

history._pushState = history.pushState;
history.pushState = function(state, title, url) {
	instance.load(state);

	// Track in analytics
	reportPageView(url, title);

	if (history._pushState !== undefined) {
		// Call original pushState
		history._pushState(prepForSerializing(state), title, url);
	}
};

history._replaceState = history.replaceState;
history.replaceState = function(state, title, url) {
	instance.load(state)

	// Track in analytics
	reportPageView(url, title, true);

	if (history._replaceState !== undefined) {
		history._replaceState(state, title, url);
	}
};

function getBaseUrl(url){
	var indexOfQuestionMark = url.indexOf("?");
	return indexOfQuestionMark !== -1 ? url.substring(0, indexOfQuestionMark) : url;
}

instance._initialLocationHref = window.location.href;
window.onpopstate = function(event) {
	if (getBaseUrl(window.location.href) !== getBaseUrl(instance._initialLocationHref)) {
		window.location.reload();
	}

	instance.load(event.state);

	// Track in analytics
	var title = instance.getStateTitle();
	if (title === null)
		title = document.title + ' (Pushed Back)';
	reportPageView(document.location.href, title);
};

module.exports = {
	instance: instance,
	StateHolder: StateHolder
};
